<template>
  <div class="shop-container all-box" ref="mainContainer">
    <div class="shop-item-container">
      <Empty
        v-if="datas.records.total < 1 && !hasInsertedFixedItem"
        text="当前暂无活动，敬请期待"
      ></Empty>
      <div class="shop-item-box" ref="gridContainer" v-else>
        <div
          class="items-container fixed-item"
          ref="fixedGridItem"
          v-if="hasInsertedFixedItem"
        >
          <router-link
            :to="{
              name: 'ZfMsg',
            }"
          >
            <div class="items-image">
              <ListImage
                :url="zfShopImg"
                @load="imageLoaded"
                style="width: 100%; height: auto"
              />
            </div>
          </router-link>
        </div>
        <div
          class="items-container"
          ref="gridItem"
          v-for="(item, index) in datas.records.data"
          :key="item.id || index"
        >
          <div class="items-image">
            <ListImage
              :url="
                item.isFixed
                  ? zfShopImg
                  : 'https://clubs.xinmin.cn/' + item.image
              "
              @load="imageLoaded"
              style="width: 100%; height: auto"
            />
          </div>
          <div class="items-text-container" v-if="!item.isFixed">
            <el-text class="items-name" tag="b" line-clamp="2">{{
              item.name
            }}</el-text>
            <div class="items-bottom-container">
              <div class="items-info">
                <div>
                  <el-text tag="b" class="price">{{ item.jifen }}积分</el-text>
                </div>
                <div v-if="item.count > 0">
                  <el-text>库存</el-text
                  ><el-text class="count">{{ item.count }}</el-text>
                </div>
              </div>
              <el-button
                class="items-btn"
                disabled
                round
                size="small"
                @click="handleButtonStatus(item)"
                v-if="item.order_status === 0 && item.count < 1"
                style="border: 0; padding-right: 0"
                >已售罄</el-button
              >
              <el-button
                class="items-btn"
                color="#ffd5ab"
                round
                size="small"
                @click="handleButtonStatus(item)"
                v-if="item.order_status === 0 && item.count > 0"
                >去兑换</el-button
              >
              <el-button
                class="items-btn"
                color="#ffd5ab"
                round
                size="small"
                @click="handleButtonStatus(item)"
                v-else-if="item.order_status === 1"
                >使用</el-button
              >
              <el-button
                class="items-btn"
                disabled
                round
                size="small"
                v-else-if="item.order_status === 2"
                style="border: 0; padding-right: 0"
                >已兑换</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="loading"
      element-loading-text="加载中..."
      v-loading="isLoading"
      v-if="!isNotMore"
      :style="{ paddingTop: datas.records.total !== 0 ? 0 : '150px' }"
    ></div>
    <div class="noMore" v-if="isNotMore">——— 我是有底线的 ———</div>
    <div class="allDialog" v-if="selectedItem != null">
      <el-dialog
        :title="
          selectedItem.order_status === 0 ? '提示' : '请联系工作人员确认核销'
        "
        v-model="showDialog"
        width="70%"
        top="36vh"
        :show-close="false"
        center
        destroy-on-close
      >
        <div v-if="selectedItem.order_status === 0">
          <p>是否立即兑换？</p>
        </div>
        <div v-else>
          <el-input placeholder="请填写核销码" v-model="key" />
        </div>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="showDialog = false">取 消</el-button>
            <el-button
              @click="confirmExchange"
              v-if="selectedItem.order_status === 0"
              >确 认</el-button
            >
            <el-button @click="confirmUsechange" style="color: #ee5f5c" v-else
              >确认核销</el-button
            >
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import fetchData from "@/mixins/fetchData.js";
import {
  getInterList,
  postInterSubmit,
  postVerificationSubmit,
} from "@/api/shop.js";
import mainScroll from "@/mixins/mainScroll.js";
import ListImage from "@/components/ListImage";
import Empty from "@/components/Empty";
import zfShopImg from "@/assets/shop_zf.jpg";
export default {
  components: {
    ListImage,
    Empty,
  },
  mixins: [fetchData({ records: { total: 0 } }), mainScroll("mainContainer")],
  data() {
    return {
      storage: window.localStorage,
      page: 1,
      limit: 10,
      isNotMore: false,
      showDialog: false,
      buttonStatus: 0,
      selectedItem: null,
      key: "",
      zfShopImg,
      hasInsertedFixedItem: false, // 控制固定项显示
    };
  },
  created() {
    this.$bus.$on("mainScroll", this.handleScroll);
  },
  async mounted() {
    // 确保先初始化固定项
    this.initFixedItem();
    await this.fetchData();
    this.$nextTick(() => {
      window.addEventListener("resize", this.initWaterfallLayout);
      this.initWaterfallLayout();
    });
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.initWaterfallLayout);
  },
  unmounted() {
    this.$bus.$off("mainScroll", this.handleScroll);
  },
  methods: {
    // 初始化固定项
    initFixedItem() {
      this.hasInsertedFixedItem = true;
    },

    async fetchData() {
      const resp = await getInterList(
        this.storage.getItem("uid"),
        this.storage.getItem("usertoken"),
        this.page,
        this.limit
      );

      this.datas.records = resp.records;
      return resp;
    },

    handleScroll(dom) {
      if (this.isLoading || !dom) {
        return;
      }
      const range = 20;
      const dec = Math.abs(dom.scrollTop + dom.clientHeight - dom.scrollHeight);
      if (dec <= range) {
        this.fetchMore();
      }
    },

    async fetchMore() {
      if (!this.hasMore) {
        this.isNotMore = true;
        return;
      }
      this.isLoading = true;
      this.page++;
      const resp = await getInterList(
        this.storage.getItem("uid"),
        this.storage.getItem("usertoken"),
        this.page,
        this.limit
      );

      this.datas.records.data = this.datas.records.data.concat(
        resp.records.data
      );
      this.datas.records.total = resp.records.total;

      this.$nextTick(() => {
        this.initWaterfallLayout();
      });
      this.isLoading = false;
    },

    initWaterfallLayout() {
      requestAnimationFrame(() => {
        const container = this.$refs.gridContainer;
        if (!container) return;

        // 收集所有项目（固定项 + 普通项）
        let allItems = [];
        if (this.hasInsertedFixedItem && this.$refs.fixedGridItem) {
          allItems.push(this.$refs.fixedGridItem);
        }
        if (Array.isArray(this.$refs.gridItem)) {
          allItems = allItems.concat(this.$refs.gridItem);
        }

        if (allItems.length === 0) {
          console.error("没有可布局的项目");
          return;
        }

        // 瀑布流布局设置
        const columnCount = 2;
        const columnHeights = Array(columnCount).fill(0);
        const gutter = 10;

        const columnWidth =
          (container.clientWidth - gutter * (columnCount - 1)) / columnCount;

        allItems.forEach((item) => {
          item.style.position = "absolute";
          item.style.width = `${columnWidth}px`;

          const itemHeight = item.offsetHeight;
          const minHeight = Math.min(...columnHeights);
          const minColumnIndex = columnHeights.indexOf(minHeight);

          item.style.transform = `translate(${
            minColumnIndex * (columnWidth + gutter)
          }px,${minHeight}px)`;

          columnHeights[minColumnIndex] += itemHeight + gutter;
        });

        const containerHeight = Math.max(...columnHeights);
        container.style.height = `${containerHeight - gutter}px`;
      });
    },

    imageLoaded() {
      this.$nextTick(() => {
        this.initWaterfallLayout();
      });
    },

    handleButtonStatus(item) {
      this.selectedItem = item;
      this.showDialog = true;
      this.key = "";
    },

    async confirmExchange() {
      const resp = await postInterSubmit({
        id: this.selectedItem.id,
        uid: this.storage.getItem("uid"),
        usertoken: this.storage.getItem("usertoken"),
      });

      if (!resp.status) {
        this.$message.warning({
          message: resp.message,
          type: "warning",
          center: true,
          offset: 90,
          duration: 1500,
          customClass: "message-class",
        });
      } else {
        this.selectedItem.order_status = 1;
        this.showDialog = false;
        this.$message.success({
          message: resp.message,
          type: "success",
          center: true,
          offset: 90,
          duration: 1500,
          customClass: "message-class",
        });
      }
    },

    async confirmUsechange() {
      const resp = await postVerificationSubmit({
        id: this.selectedItem.id,
        key: this.key,
        uid: this.storage.getItem("uid"),
        usertoken: this.storage.getItem("usertoken"),
      });

      if (!resp.status) {
        this.$message.warning({
          message: resp.message,
          type: "warning",
          center: true,
          offset: 90,
          duration: 1500,
          customClass: "message-class",
        });
      } else {
        this.selectedItem.order_status = 2;
        this.showDialog = false;
        this.$message.success({
          message: resp.message,
          type: "success",
          center: true,
          offset: 90,
          duration: 1500,
          customClass: "message-class",
        });
      }
    },
  },
  computed: {
    hasMore() {
      const actualDataLength = this.datas.records.data.length;
      return actualDataLength < this.datas.records.total;
    },
  },
  watch: {
    "datas.records.data": function () {
      if (this.datas.records.data.length > 0) {
        this.$nextTick(() => {
          this.initWaterfallLayout();
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/mixin.less";

.shop-container {
  position: relative;
  margin: auto;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-behavior: smooth;
  overscroll-behavior-y: none;
  height: 100%;
  .shop-item-container {
    position: relative;
    width: 96%;
    margin: auto;
    padding-top: 10px;
    .shop-item-box {
      position: relative;
      width: 100%;
      margin: auto;
    }
  }
  .items-container {
    border-radius: 10px;
    background-color: #fff;
    border: 1px solid #f0f0f0;
    overflow: hidden;
    box-sizing: border-box;
    margin: auto;
    .items-image {
      .list-image-container {
        margin: auto;
        border-radius: 0;
      }
    }
    .items-text-container {
      width: 90%;
      margin: 10px auto;
      text-align: left;
      .items-name {
        letter-spacing: 1px;
        font-size: 14px;
        line-height: normal;
        color: rgba(0, 0, 0, 0.7);
      }
      .items-bottom-container {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-top: 10px;
        .items-info {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          div {
            width: 100%;
          }
        }
      }
      b {
        font-size: 18px;
        color: var(--zfMsg-publish);
      }
      span {
        font-size: 14px;
        color: var(--ccc);
      }
    }
  }
}

.loading {
  background: transparent;
  margin: 20px 0;
  height: 20px;
}

.noMore {
  color: var(--ccc);
  margin: 20px 0;
  height: 20px;
  font-size: 14px;
}
</style>